import { useState, useEffect } from "react"
import { Header } from "@/components/header"
import { HeroSection } from "@/components/hero-section"
import { TitleSection } from "@/components/title-section"
import { FeatureGrid } from "@/components/feature-grid"
import { LoginModal } from "@/components/login-modal"
import { ClaimSharesDialog } from "@/components/claim-shares-dialog"
import { isLoggedIn as checkIsLoggedIn } from '@/api/auth'

export default function Home() {
  const [showLogin, setShowLogin] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showClaimDialog, setShowClaimDialog] = useState(false)

  // 页面加载时检查登录状态
  useEffect(() => {
    setIsLoggedIn(checkIsLoggedIn())
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-100 via-blue-50 to-cyan-50 relative overflow-hidden">
      {/* Background decorative blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-200/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      <div className="absolute bottom-20 left-20 w-64 h-64 bg-pink-200/20 rounded-full blur-3xl" />

      <Header isLoggedIn={isLoggedIn} onLoginClick={() => setShowLogin(true)} />

      <main className="max-w-[1500px] mx-auto px-12 py-6 relative z-10 flex items-center min-h-[calc(100vh-140px)]">
        <div className="grid lg:grid-cols-[320px_minmax(480px,1fr)_640px] gap-8 items-center">
          <HeroSection 
            onLoginClick={() => setShowLogin(true)}
            isLoggedIn={isLoggedIn}
          />
          <TitleSection 
            onLoginClick={() => setShowLogin(true)}
          />
          <FeatureGrid />
        </div>
      </main>

      <LoginModal
        open={showLogin}
        onClose={() => setShowLogin(false)}
        onSuccess={(hasClaimableShares) => {
          setIsLoggedIn(true)
          setShowLogin(false)
          // 如果有可认领的分享，显示认领对话框
          if (hasClaimableShares) {
            setTimeout(() => setShowClaimDialog(true), 500)
          }
        }}
      />

      <ClaimSharesDialog
        open={showClaimDialog}
        onClose={() => setShowClaimDialog(false)}
        onClaimed={() => {
          // 认领成功后可以刷新页面或显示提示
          console.log('分享已认领')
        }}
      />
    </div>
  )
}
